export default __webpack_public_path__ + "static/media/logout.5e4e0483.svg";